import { sharedInteramericanFields } from '@/views/checkouts/companies/Interamerican/shared/sharedInteramericanSchema';
import * as yup from 'yup';

export const BikeInteramericanSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedInteramericanFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      false,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
  });
};

export default BikeInteramericanSchemaBuilder;
